var map = {
	"./aparthotelclub/ic_wikipedia_link_circle.png": 26280,
	"./beachful/ic_wikipedia_link_circle.png": 63878,
	"./castlepedia/ic_wikipedia_link_circle.png": 73320,
	"./cocktayl/ic_wikipedia_link_circle.png": 80725,
	"./ic_wikipedia_link_circle.png": 66287,
	"./luxresortclub/ic_wikipedia_link_circle.png": 44275,
	"./parkful/ic_wikipedia_link_circle.png": 40350,
	"./prefabworld/ic_wikipedia_link_circle.png": 17210,
	"./rooftopclub/ic_wikipedia_link_circle.png": 96905,
	"./spaclub/ic_wikipedia_link_circle.png": 11056,
	"./worldcasino/ic_wikipedia_link_circle.png": 35432,
	"./zoopedia/ic_wikipedia_link_circle.png": 94971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71808;